
import { useState } from 'react';
import { safetyTips } from '../../../mocks/emergency';

export default function SafetyTipsSection() {
  const [activeTip, setActiveTip] = useState(safetyTips[0].id);
  const currentTip = safetyTips.find((t) => t.id === activeTip) || safetyTips[0];

  return (
    <section id="safety-tips" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-teal-600 bg-teal-50 text-sm font-medium px-4 py-1.5 rounded-full mb-4">
            <i className="ri-shield-check-line"></i>
            Be Prepared
          </span>
          <h2 className="text-3xl font-bold text-gray-900 mb-3">Safety &amp; Preparedness Tips</h2>
          <p className="text-gray-600 text-sm max-w-xl mx-auto">Practical guidance to keep you and your family safe in any situation</p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          {/* Category Sidebar */}
          <div className="lg:w-72 flex-shrink-0">
            <div className="flex lg:flex-col gap-2 overflow-x-auto lg:overflow-visible pb-2 lg:pb-0">
              {safetyTips.map((tip) => (
                <button
                  key={tip.id}
                  onClick={() => setActiveTip(tip.id)}
                  className={`flex items-center gap-3 px-5 py-3.5 rounded-xl text-sm font-medium transition-all whitespace-nowrap cursor-pointer text-left ${
                    activeTip === tip.id
                      ? 'bg-teal-600 text-white shadow-md'
                      : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
                  }`}
                >
                  <div className={`w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0 ${
                    activeTip === tip.id ? 'bg-white/20' : 'bg-gray-100'
                  }`}>
                    <i className={`${tip.icon} text-base ${activeTip === tip.id ? 'text-white' : 'text-gray-500'}`}></i>
                  </div>
                  {tip.title}
                </button>
              ))}
            </div>
          </div>

          {/* Tips Content */}
          <div className="flex-1">
            <div className="bg-white rounded-2xl border border-gray-200 p-8 shadow-sm">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 bg-teal-50 rounded-xl flex items-center justify-center">
                  <i className={`${currentTip.icon} text-teal-600 text-2xl`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">{currentTip.title}</h3>
                  <p className="text-gray-500 text-xs mt-0.5">Roseville &amp; Placer County</p>
                </div>
              </div>

              <ul className="space-y-4">
                {currentTip.tips.map((tip, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <span className="w-7 h-7 bg-teal-50 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <span className="text-teal-600 text-xs font-bold">{idx + 1}</span>
                    </span>
                    <p className="text-gray-700 text-sm leading-relaxed">{tip}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
